// emailHelper.ts
import {
  Configuration,
  EmailsApi,
  EmailMessageData,
} from '@elasticemail/elasticemail-client-ts-axios';

const apiKey = process.env.GATSBY_ELASTIC_API_KEY;

const config = new Configuration({
  apiKey: apiKey,
});

const emailsApi = new EmailsApi(config);

export const sendEmail = (
  recipients: { email: string; name: string }[],
  subject: string,
  templateName: string,
  fields: { [key: string]: any },
  ccRecipients: { email: string; name: string }[] = []
) => {
  const allRecipients = [
    ...recipients.map((recipient) => ({
      Email: recipient.email,
      Fields: {
        name: recipient.name,
      },
    })),
    ...ccRecipients.map((cc) => ({
      Email: cc.email,
      Fields: {
        name: cc.name,
      },
      RecipientType: 'CC',
    })),
  ];

  const emailMessageData: EmailMessageData = {
    Recipients: allRecipients,
    Content: {
      TemplateName: templateName,
      Subject: subject,
      From: 'noreply@intrack.com.my',
      Merge: fields,
    },
  };

  return emailsApi.emailsPost(emailMessageData);
};
